import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          用户评价
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12 max-w-[600px] mx-auto">
          听听使用国产91视频的用户怎么说
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-[1100px] mx-auto">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-100 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 mt-3">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}